import * as React from 'react';
import { useTranslations } from 'i18n';
import { useGetMappedUserLanguage } from 'shared/language/use-get-mapped-user-language';
import { buildHighchartsLang, publishHighchartsLang } from 'highcharts-lang';

/** Keeps Highcharts' own strings and dates in the app language (numbers stay English); mount once under I18nProvider. */
export const HighchartsLocale: React.FC = () => {
    const { __ } = useTranslations();
    const locale = useGetMappedUserLanguage();

    // layout effect so the lang is in place before sibling charts (HighchartsReact) create or update theirs
    React.useLayoutEffect(() => {
        publishHighchartsLang(buildHighchartsLang(__, locale));
    }, [__, locale]);

    return null;
};
